//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  components: {

  },
  data () {
    return {
      options: {
        navigation: true,
        navigationPosition: 'left',
        // navigationColor: ['#fff'],
        licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
        sectionSelector: '.section',
        afterLoad: this.afterLoad
      }
    }
  },
  methods: {
    afterLoad (origin, destination, direction) {
      console.log('After load....')
      console.log(destination)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Memories.vue